import { createSelector, createSlice } from '@reduxjs/toolkit';
export const initialFormEmbedderState = {
    activeFormEmbedderType: null,
};
export const formEmbedderSlice = createSlice({
    name: 'formEmbedder',
    initialState: initialFormEmbedderState,
    reducers: {
        changeForm: (state, actions) => {
            state.activeFormEmbedderType = actions.payload;
        },
    },
});
export const formEmbedderActions = formEmbedderSlice.actions;
const loginRegistrationFormEmbedderState = (state) => state.wrappers.formEmbedder;
export const activeFormEmbedderTypeSelector = createSelector(loginRegistrationFormEmbedderState, ({ activeFormEmbedderType }) => activeFormEmbedderType);
export const isFormEmbedderTypeVisible = (formType) => createSelector(loginRegistrationFormEmbedderState, ({ activeFormEmbedderType }) => {
    return activeFormEmbedderType === formType;
});
export default formEmbedderSlice.reducer;
//# sourceMappingURL=formEmbedderSlice.js.map